import React, {useMemo, useState} from 'react';
import {DateManager, getAppPrimaryDateTimeFormat} from "../Reusable/TimeDateManager";
import {fileDownloader, formatPrice, getApiErrorMsg} from "../../utils/helper";
import axios from "axios";
import {BASE_URL} from "../../config.json";
import {toast} from "react-toastify";
import ENUMS from "../../utils/ENUMS";


const token = localStorage.getItem(ENUMS.AUTH);


const handleDownloadTxnInvoice = async (txnId) => {
    try {

        const res = await axios.get(`${BASE_URL}/club/txns/invoice/download/` + txnId, {
            headers: {
                Authorization: `Bearer ${token}`
            },
        })
        const url = res.data.data
        
        if (!url) toast.error('Unable to download invoice')
        return url
    } catch (e) {
        const err = getApiErrorMsg(e)
        toast.error(err)
        return Promise.reject(e)
    }
}

const mapTxnListData = (txnList) => {
  if (!txnList?.length) return [];

  return txnList
    .map((txn) => {
      try {
        const plan = txn?.invoice?.subscription?.plan;
        const interval = plan?.interval || "month";

        const {
          id,
          type,
          amount,
          created,
          invoice: {
            number: invoiceNo = "",
            url: invoiceUrl = "",
            subscription,
          } = {},
        } = txn;

        const {
          current_period_start = null,
          current_period_end = null,
          product,
        } = subscription || {};

        const productName = product?.name || "Subscription";
        const finalProductName =
          interval === "year"
            ? "TT Yearly Subscription"
            : "TT Monthly Subscription";

        const formattedProductName =
          `${finalProductName} (${productName})\n` +
          `${DateManager(current_period_start)} - ${DateManager(current_period_end)}`;

        return {
          txnId: id,
          name: formattedProductName,
          type,
          invoiceNo,
          invoiceUrl,
          amount,
          created: getAppPrimaryDateTimeFormat(created),
        };
      } catch (err) {
        console.warn("Skipping invalid txn:", txn, err);
        return null;
      }
    })
    .filter(Boolean);
};



const TransactionItem = ({txnId, name = '', invoiceNo = '', invoiceUrl = '', amount = '', created = ''}) => {

    const [downloading, setDownloading] = useState(false)

    const handleDownload = async () => {

        if (downloading) return null

        let finalInvoiceUrl = invoiceUrl

        if (!finalInvoiceUrl) {
            try {
                setDownloading(true)
                finalInvoiceUrl = await handleDownloadTxnInvoice(txnId)
            } finally {
                setDownloading(false)
            }
        }

        if (finalInvoiceUrl) {
            fileDownloader(finalInvoiceUrl, finalInvoiceUrl.split('/').slice(-1)[0])
        }
    }


    return (
        <div className="table_detail">
            <span>{invoiceNo}</span>
            <span style={{whiteSpace: "pre-line"}}>{name}</span>
            <span>{created}</span>
            <span>{formatPrice(amount)}</span>

            <a
                className="table_detail__floating-btn"
                onClick={handleDownload}
            >
                <img src={require("../../assets/icons/download-icon.svg").default} alt="download"/>
            </a>

        </div>
    )


}


const ClubTxnList = ({txnList: _txnList}) => {


    const txnList = useMemo(() => mapTxnListData(_txnList), [_txnList])


    return (
        <div className="member__history">

            <h2 className="text-jost-sb-24">Recent History:</h2>

            <div className="member__history-table">

                <div className="table_head">
                    <span className="table__row-0">Invoice Number</span>
                    <span className="table__row-0">Description</span>
                    <span className="table__row-0">Invoice Date</span>
                    <span className="table__row-0">Amount</span>
                    {/*<span className="table__row-0">PDF</span>*/}
                </div>

                {
                    !txnList.length

                        ?
                        ''

                        :
                        txnList.map((txn, i) => <TransactionItem {...txn} key={i.toString()}/>)

                }


            </div>
        </div>
    )

};

export default ClubTxnList;
